import { LinkPillWithPopover } from "components/common/LinkPillWithPopover";
import strings from "components/release/useful-links/UsefulLinks.strings.json";
import styles from "components/release/useful-links/UsefulLinksAndroid.module.scss";
import {
  generateBuildLinks,
  generateCrashtlyticsLinks,
  generateJeevesLinks,
  generateMappingLinks,
  generatePlayConsoleANRLinks,
  generatePlayConsoleLowReviewLinks,
  generatePlayConsoleNativeCrashLinks,
  generateSentryDashboardsLinks,
  generateSentryIssueFeedLinks,
} from "components/release/useful-links/helpers";
import type { SemVer } from "util/version";

interface Props {
  versions: SemVer[];
  appBuildUrls: Record<string, string | undefined>;
}

const UsefulLinksAndroid = ({ versions, appBuildUrls }: Props) => (
  <span className={styles.container}>
    <LinkPillWithPopover
      linkPillTitle={strings.CrashlyticsCrashes}
      linkPillWidth="289px"
      popoverContent={<ul>{generateCrashtlyticsLinks(versions)}</ul>}
    />
    <LinkPillWithPopover
      linkPillTitle={strings.SentryDashboards}
      linkPillWidth="289px"
      popoverContent={<ul>{generateSentryDashboardsLinks(versions)}</ul>}
    />
    <LinkPillWithPopover
      linkPillTitle={strings.SentryIssueFeed}
      linkPillWidth="289px"
      popoverContent={<ul>{generateSentryIssueFeedLinks(versions)}</ul>}
    />
    <LinkPillWithPopover
      linkPillTitle={strings.PlayConsoleANRs}
      linkPillWidth="273px"
      popoverContent={<ul>{generatePlayConsoleANRLinks(versions)}</ul>}
    />
    <LinkPillWithPopover
      linkPillTitle={strings.PlayConsoleNativeCrashes}
      linkPillWidth="374px"
      popoverContent={<ul>{generatePlayConsoleNativeCrashLinks(versions)}</ul>}
    />
    <LinkPillWithPopover
      linkPillTitle={strings.PlayConsoleLowReviews}
      linkPillWidth="394px"
      popoverContent={<ul>{generatePlayConsoleLowReviewLinks(versions)}</ul>}
    />
    <LinkPillWithPopover
      linkPillTitle={strings.Jeeves}
      linkPillWidth="150px"
      popoverContent={<ul>{generateJeevesLinks(versions)}</ul>}
    />
    <LinkPillWithPopover
      linkPillTitle={strings.DownloadBuild}
      linkPillWidth="236px"
      popoverContent={<ul>{generateBuildLinks(versions, appBuildUrls)}</ul>}
    />
    <LinkPillWithPopover
      linkPillTitle={strings.DownloadMapping}
      linkPillWidth="271px"
      popoverContent={<ul>{generateMappingLinks(versions, appBuildUrls)}</ul>}
    />
  </span>
);

export default UsefulLinksAndroid;
